import { DatePicker, Form } from "antd";
import type { TFunction } from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";

import { DISPLAY_DATE_FORMAT } from "@/v1/constants";

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.exportSmartaBankingTransactions";
  return {
    dateRange: {
      label: t(`${keyPrefix}.dateRange.label`),
      placeholderStart: t(`${keyPrefix}.dateRange.placeholderStart`),
      placeholderEnd: t(`${keyPrefix}.dateRange.placeholderEnd`),
    },
  };
};

export const ExportSmartaBankingTransactions: React.FC = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);
  return (
    <>
      <Form.Item
        label={texts.dateRange.label}
        name="dateRange"
        className="mt-4"
      >
        <DatePicker.RangePicker
          data-testid="date-picker"
          format={DISPLAY_DATE_FORMAT}
          placeholder={[
            texts.dateRange.placeholderStart,
            texts.dateRange.placeholderEnd,
          ]}
        />
      </Form.Item>
    </>
  );
};
